
<template>
  <v-container>
    <v-row justify="center">
      <!-- <v-col cols="12" sm="2">
        <v-sheet rounded="lg" min-height="268">

        </v-sheet>
      </v-col> -->

      <v-col cols="12" sm="8">
        <v-card class="my-10">
          <v-card-text>
            <small>
              <pre>$store.state: {{ $store.state }}</pre>
            </small>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="8">
        <v-card class="my-10">
          <v-card-text>
            <small>
              <pre>$store.getters: {{ $store.getters }}</pre>
            </small>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- <v-col cols="12" sm="4">
        <v-sheet rounded="lg" min-height="268">
          <BuildingCard />
        </v-sheet>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import BuildingCard from "@/components/object/BuildingCard";
import ObjectDetails from "@/components/stepper/steps/ObjectDetails";
export default {
  components: {
    ObjectDetails,
    BuildingCard,
  },
};
</script>
